module.exports = __webpack_public_path__ + "static/media/meats.b7b5976d.png";